import { ColorSchemeDefinition, useTheme } from "@elit-hair/elit-ui";
import { useCallback } from "react";

import { SETTINGS_KEYS } from "@/constants/settings-keys";
import { useRemoteConfigInput } from "@/pages/settings/utils/use-remote-config-input";

/**
 * Hook to handle color scheme changes with remote config synchronization
 * Updates both the theme provider and remote config settings
 */
export function useColorSchemeChange() {
  const { setSelectedColorScheme } = useTheme();
  const { onChange: setColorScheme } = useRemoteConfigInput<string>(
    SETTINGS_KEYS.COLOR_SCHEME,
  );

  const handleColorSchemeChange = useCallback(
    (scheme: ColorSchemeDefinition) => {
      setSelectedColorScheme(scheme);
      setColorScheme(scheme.value);
    },
    [setSelectedColorScheme, setColorScheme],
  );

  return handleColorSchemeChange;
}
